import React, { useState } from 'react'
import styled from 'styled-components'
import { CurrencySymbolImage, ConfirmButton, Modal, Amount, Symbol, TokenAmountReceive } from '../../../common'
import { Colors, INTEGRAL_SYMBOL } from '../../../constants'
import { useEthers, useSendTransaction, TimeReleaseClaim } from '../../../hooks'
import { CurrencyValue } from '../../../model'
import { getMerkleTimeReleaseClaimTransaction, getTimeReleaseClaimTransaction } from '../../../transactions'

interface Props {
  option1Claimable: CurrencyValue
  option2Claimable: CurrencyValue
  timeReleaseAddress: string
  timeReleaseClaim?: TimeReleaseClaim
  onClose: () => void
  onSubmit: () => void
}

export function ConfirmClaim({
  option1Claimable,
  option2Claimable,
  timeReleaseAddress,
  timeReleaseClaim,
  onClose,
  onSubmit,
}: Props) {
  const { chainId, account } = useEthers()
  const sendTransaction = useSendTransaction()
  const [sending, setSending] = useState(false)

  async function claim() {
    if (!chainId || !account || !option1Claimable || !option2Claimable) {
      return
    }
    setSending(true)
    try {
      const tx = timeReleaseClaim
        ? getMerkleTimeReleaseClaimTransaction(
            account,
            timeReleaseAddress,
            option1Claimable,
            option2Claimable,
            timeReleaseClaim
          )
        : getTimeReleaseClaimTransaction(account, timeReleaseAddress, option1Claimable, option2Claimable)
      await sendTransaction(tx)
      setSending(false)
      onSubmit()
    } catch (err) {
      setSending(false)
      if (err instanceof Error) {
        alert(err.message) // TODO: better error handling
      }
    }
  }

  const totalClaimable = new CurrencyValue(
    option1Claimable.currency,
    option1Claimable.value.add(option2Claimable.value)
  )

  return (
    <Modal title="Confirm Claim" onClose={onClose}>
      <Content>
        <TokenAmountReceive>
          <Amount>{totalClaimable.format()}</Amount>
          <Symbol>
            <CurrencySymbolImageStyled symbol={INTEGRAL_SYMBOL} />
            {INTEGRAL_SYMBOL}
          </Symbol>
        </TokenAmountReceive>
        <ConfirmButtonStyled onClick={claim} sending={sending} />
      </Content>
    </Modal>
  )
}

const Content = styled.div`
  padding: 15px 20px;
  color: ${Colors.Black};
`

const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`

const ConfirmButtonStyled = styled(ConfirmButton)`
  margin-top: 20px;
`
